import React from "react";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";

interface Props {
  editedCount: number;
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

/** Edit-mode action bar: shows how many objects changed and commits or discards the batch. */
const ScopesEditBar = ({ editedCount, saving, onCancel, onSave }: Props) => {
  // render
  return (
    <div className="flex items-center gap-3">
      <Text variant="sm" className="text-gray-40">
        {editedCount} object{editedCount === 1 ? "" : "s"} edited
      </Text>
      <Button variant={ButtonVariant.SecondaryGray} onClick={onCancel}>
        Cancel
      </Button>
      <Button
        variant={ButtonVariant.PrimaryGray}
        onClick={onSave}
        loading={saving}
        disabled={editedCount === 0}
      >
        Save changes
      </Button>
    </div>
  );
};

export default ScopesEditBar;
